import React from "react";
import { Search } from "lucide-react";
import { getAnalysisColorClasses } from "../../utils/analysisUtils";
import CardContainer from "../Containers/CardContainer";
import Heading from "../Headers/Heading";
import SentenceCard from "../Cards/SentenceCard";
import BlockButton from "../Buttons/BlockButton";
import StatusCard from "../Cards/StatusCard";
import UserResponseCard from "../Cards/UserResponseCard";
import FormattedResponse from "../Response/FormattedResponse";
import AnalysisCard from "../Cards/AnalysisCard";

const PracticeSection = ({
  dialogState,
  isListening,
  userResponse,
  analysisReport,
  onStartListening,
  onAnalyze,
  colorClass
}) => {
  return (
    <div className="space-y-6">
      {/* Status Card */}
      <StatusCard
        dialogState={dialogState}
        isListening={isListening}
        onStartListening={onStartListening}
      />

      {/* User Response */}
      {userResponse && <UserResponseCard 
        userResponse={userResponse} 
        className="bg-gray-50 border-dashed border-gray-300" 
      />}

      {/* Analysis Section */}
      <AnalysisCard
        onClick={onAnalyze}
        analysisReport={analysisReport}
        className={colorClass}
      />
    </div>
  );
};

export default PracticeSection;
